import { NotificationAppearance, setDjangoToastOpen } from "./djangoToastSlice";
import { ProductListParams } from "../products/product-list/ProductListURLConfig";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { prepareCustomHeaders } from "../utils/baseQueryHeaders";
import { store } from "../utils/store";

type IdQueryBodyType = {
  id_type: string;
  query: string;
  url_params?: ProductListParams;
};

type IdQueryResultType = {
  error_message?: string;
  redirect_url: string;
  id_list: string[];
  not_found_ids: string[];
  found_ids: string[];
};

export const idQueryApi = createApi({
  reducerPath: "idQueryApi",
  tagTypes: ["IdQuery"],
  baseQuery: fetchBaseQuery({
    baseUrl: "/api/_internal/product",
    prepareHeaders: prepareCustomHeaders,
  }),
  endpoints: (build) => ({
    parseIdQuery: build.mutation<IdQueryResultType, IdQueryBodyType>({
      query: (body) => ({
        url: `/parse_id_query/`,
        method: "POST",
        body,
      }),
      transformResponse: (responseData: IdQueryResultType) => {
        // errors by documentation should be handled by queryFn https://redux-toolkit.js.org/rtk-query/usage/customizing-queries#customizing-queries-with-queryfn
        // but here we want to still keep content in textarea
        if (responseData?.error_message) {
          store.dispatch(
            setDjangoToastOpen({
              appearance: NotificationAppearance.ERROR,
              content: responseData.error_message,
            })
          );
        }
        return responseData;
      },
    }),
  }),
});

export const { useParseIdQueryMutation } = idQueryApi;
